<script>
  import { faStar } from '@fortawesome/free-solid-svg-icons/faStar'
  import { mergeData } from 'vue-functional-data-merge'
  import Lender from '~/modules/users/entities/frontend/lender'
  import { translator } from '~/plugins/i18n'
  import i18n from './locales'

  export default {
    name: 'LenderBlockBadge',
    functional: true,
    render (h, { data, parent }) {
      parent.$fa.add(faStar)

      const icon = h('font-awesome-icon', {
        props: {
          icon: ['fa', 'star'],
        },
      })
      const label = h('span', {
        domProps: {
          innerHTML: i18n.messages[translator.locale].label,
        },
      })

      const propsData = {
        props: {
          to: {
            name: 'angels:frontend:index',
          },
        },
        staticClass: 'lender-angel-badge',
      }

      return h('vb-link', mergeData(propsData, data), [label, icon])
    },
    props: {
      lender: {
        type: Lender,
        required: true,
      },
    },
    data () {
      return {
        route: {
          name: 'angels:frontend:index',
        },
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import "~assets/scss/frontend/_colours";
  @import "~foundation-sites/scss/util/_unit";

  .lender-angel-badge {
    background-color: $colour-orange;
    border-radius: 1rem;
    color: $colour-white;
    display: inline-block;
    font-size: rem-calc(8);
    line-height: rem-calc(12);
    padding: rem-calc(1 7 2);
    text: {
      decoration: none !important;
      transform: uppercase;
    }
    transition: background-color .2s ease-out;

    &:hover {
      background-color: scale-color($colour-orange, $lightness: 20%);
    }

    svg {
      margin-left: rem-calc(1);
    }
  }
</style>
